/**
 * Centralized feature flag names
 *
 * This file contains all feature flag names used in the application.
 * Always use these constants instead of hardcoding flag names to ensure consistency
 * and make it easier to track and manage feature flags.
 */

export const FeatureFlags = {
  /**
   * Controls the visibility of the webhook routing section
   */
  WEBHOOK_ROUTING: 'webhook-routing',
  /**
   * Controls the visibility of the transformations feature
   */
  TRANSFORMATIONS: 'transformations',
  /**
   * Controls the visibility of sources and destinations management
   */
  SOURCES_DESTINATIONS: 'sources-destinations',
} as const;

/**
 * Type representing all available feature flags
 */
export type FeatureFlagName = (typeof FeatureFlags)[keyof typeof FeatureFlags];

export default FeatureFlags;
